import React from 'react';
import { Container } from '../components/Container';
import { Store, DollarSign, Users, Clock, CheckCircle2, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TeamStores() {
  return <div className="w-full bg-white" data-id="element-621">
      {/* Hero */}
      <div className="bg-[#111827] text-white py-12 lg:py-16" data-id="element-622">
        <Container data-id="element-623">
          <div className="flex flex-col lg:flex-row items-center gap-10" data-id="element-624">
            <div className="lg:w-1/2" data-id="element-625">
              <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-3 leading-tight" data-id="element-626">
                Custom Team Stores
              </h1>
              <div className="w-16 h-1.5 bg-pts-red mb-5" data-id="element-627"></div>
              <p className="text-lg text-gray-300 mb-6 leading-relaxed" data-id="element-628">
                Take the hassle out of ordering fan gear. Open a custom online
                store for your organization, let parents order directly, and
                raise funds effortlessly.
              </p>
              <Link to="/contact" className="inline-block bg-pts-red hover:bg-pts-red-dark text-white px-7 py-3 rounded font-bold uppercase tracking-wide transition-colors" data-id="element-629">
                Start a Team Store
              </Link>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-630">
              <img src="https://cdn.magicpatterns.com/uploads/4Ruc1nsuJQkNnM2DaogboL/team-apparel-stores.jpg" alt="Custom team apparel product collection" className="rounded-xl shadow-2xl border border-gray-800 w-full h-auto" data-id="element-631" />
            </div>
          </div>
        </Container>
      </div>

      {/* How It Works */}
      <section className="py-20 bg-gray-50" data-id="element-632">
        <Container data-id="element-633">
          <div className="text-center mb-16" data-id="element-634">
            <h2 className="font-oswald text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-635">
              How Team Stores Work
            </h2>
            <div className="w-24 h-1.5 bg-pts-red mx-auto" data-id="element-636"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-637">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-638">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-639">
                1
              </div>
              <Store className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-640" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-641">
                We Build the Store
              </h3>
              <p className="text-gray-600" data-id="element-642">
                You pick the gear and provide your logos. We build a custom,
                mobile-friendly online store for your organization.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-643">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-644">
                2
              </div>
              <Users className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-645" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-646">
                Parents & Fans Order
              </h3>
              <p className="text-gray-600" data-id="element-647">
                Share the link with your organization. Everyone orders and pays
                individually during a set time window.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 text-center relative" data-id="element-648">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-pts-red text-white rounded-full flex items-center justify-center font-oswald text-xl font-bold border-4 border-gray-50" data-id="element-649">
                3
              </div>
              <Clock className="h-10 w-10 text-gray-400 mx-auto mb-4 mt-4" data-id="element-650" />
              <h3 className="font-oswald text-xl font-bold uppercase mb-3 text-gray-900" data-id="element-651">
                We Produce & Ship
              </h3>
              <p className="text-gray-600" data-id="element-652">
                The store closes, we produce all the orders together, and ship
                them out. No inventory or money collection for you.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Fundraising */}
      <section className="py-20 bg-white border-y border-gray-200" data-id="element-653">
        <Container data-id="element-654">
          <div className="flex flex-col md:flex-row items-center gap-12 max-w-5xl mx-auto" data-id="element-655">
            <div className="md:w-1/3 flex justify-center" data-id="element-656">
              <div className="w-48 h-48 bg-red-50 rounded-full flex items-center justify-center border-8 border-white shadow-xl" data-id="element-657">
                <DollarSign className="h-24 w-24 text-pts-red" data-id="element-658" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-659">
              <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase mb-4 text-gray-900" data-id="element-660">
                Built-In Fundraising
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-661">
                Team stores are one of the easiest ways to raise money for your
                program. We provide you with our base factory-direct pricing,
                and you decide how much markup to add to each item.
              </p>
              <ul className="space-y-3" data-id="element-662">
                <li className="flex items-center text-gray-700" data-id="element-663">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-664" /> You
                  control the retail price
                </li>
                <li className="flex items-center text-gray-700" data-id="element-665">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-666" /> We send
                  you a check for the profits after the store closes
                </li>
                <li className="flex items-center text-gray-700" data-id="element-667">
                  <CheckCircle2 className="h-5 w-5 text-pts-red mr-3" data-id="element-668" /> No
                  upfront costs or leftover inventory
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </section>

      {/* Get Your Team Store Started */}
      <section className="py-20 bg-gray-50" data-id="element-669">
        <Container data-id="element-670">
          <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden" data-id="element-671">
            <div className="grid grid-cols-1 lg:grid-cols-5" data-id="element-672">
              {/* Left: Pitch */}
              <div className="lg:col-span-2 bg-[#111827] text-white p-10 lg:p-12 flex flex-col" data-id="element-673">
                <div className="inline-block self-start bg-pts-red text-white text-xs font-bold uppercase tracking-widest px-3 py-1 rounded mb-6" data-id="element-674">
                  Let's Get Your Gear Online
                </div>
                <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase mb-4 leading-tight" data-id="element-675">
                  Get Your Club, Team, or School Gear Online
                </h2>
                <div className="w-16 h-1 bg-pts-red mb-6" data-id="element-676"></div>
                <p className="text-gray-300 mb-8 leading-relaxed" data-id="element-677">
                  Tell us about your organization and we'll set up a
                  team-specific online store where your players, parents, and
                  fans can easily purchase your gear. No setup fees, no
                  inventory, no headaches.
                </p>

                <ul className="space-y-3 mb-10 text-sm text-gray-300" data-id="element-678">
                  <li className="flex items-center" data-id="element-679">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-680" />
                    Built and hosted by PTS
                  </li>
                  <li className="flex items-center" data-id="element-681">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-682" />
                    Optional fundraising markup
                  </li>
                  <li className="flex items-center" data-id="element-683">
                    <CheckCircle2 className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-684" />
                    We produce and ship every order
                  </li>
                </ul>

                <div className="mt-auto space-y-3 pt-6 border-t border-gray-700" data-id="element-685">
                  <a href="tel:8882188647" className="flex items-center text-white hover:text-pts-red transition-colors" data-id="element-686">
                    <Phone className="h-5 w-5 text-pts-red mr-3" data-id="element-687" />
                    <span className="font-bold" data-id="element-688">888.218.8647</span>
                  </a>
                  <a href="mailto:savemoney@getcustomuniforms.com" className="flex items-center text-gray-300 hover:text-white transition-colors text-sm" data-id="element-689">
                    <Mail className="h-5 w-5 text-pts-red mr-3 flex-shrink-0" data-id="element-690" />
                    <span className="break-all" data-id="element-691">
                      savemoney@getcustomuniforms.com
                    </span>
                  </a>
                </div>
              </div>

              {/* Right: Form */}
              <div className="lg:col-span-3 p-10 lg:p-12" data-id="element-692">
                <h3 className="font-oswald text-2xl font-bold uppercase text-gray-900 mb-2" data-id="element-693">
                  Request Your Team Store
                </h3>
                <p className="text-gray-600 mb-8 text-sm" data-id="element-694">
                  Fill this out and a PTS team member will follow up within one
                  business day.
                </p>

                <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-695">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-696">
                    <div data-id="element-697">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-698">
                        Your Name *
                      </label>
                      <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-699" />
                    </div>
                    <div data-id="element-700">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-701">
                        Your Role
                      </label>
                      <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-702">
                        <option data-id="element-703">Select role</option>
                        <option data-id="element-704">Coach</option>
                        <option data-id="element-705">Team Manager</option>
                        <option data-id="element-706">Athletic Director</option>
                        <option data-id="element-707">Parent</option>
                        <option data-id="element-708">Club / League Director</option>
                        <option data-id="element-709">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-710">
                    <div data-id="element-711">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-712">
                        Email *
                      </label>
                      <input type="email" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-713" />
                    </div>
                    <div data-id="element-714">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-715">
                        Phone
                      </label>
                      <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-716" />
                    </div>
                  </div>

                  <div data-id="element-717">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-718">
                      Organization / Team / School Name *
                    </label>
                    <input type="text" required placeholder="e.g. Boca Raton Wildcats Baseball" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-719" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-720">
                    <div data-id="element-721">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-722">
                        Sport / Type
                      </label>
                      <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-723">
                        <option data-id="element-724">Select sport</option>
                        <option data-id="element-725">Baseball</option>
                        <option data-id="element-726">Basketball</option>
                        <option data-id="element-727">Football</option>
                        <option data-id="element-728">Softball</option>
                        <option data-id="element-729">Soccer</option>
                        <option data-id="element-730">Cheer</option>
                        <option data-id="element-731">Volleyball</option>
                        <option data-id="element-732">Track & Field</option>
                        <option data-id="element-733">Groupwear / Other</option>
                      </select>
                    </div>
                    <div data-id="element-734">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-735">
                        Approx. # of Members
                      </label>
                      <input type="text" placeholder="e.g. 25 players + parents" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none" data-id="element-736" />
                    </div>
                  </div>

                  <div data-id="element-737">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-738">
                      Tell us about your team store
                    </label>
                    <textarea rows={4} placeholder="What gear are you thinking about? Are you using this for fundraising? When would you like the store to open?" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none resize-none" data-id="element-739"></textarea>
                  </div>

                  <div className="pt-2" data-id="element-740">
                    <button type="submit" className="w-full bg-pts-red hover:bg-pts-red-dark text-white px-6 py-3.5 rounded font-bold uppercase tracking-wide transition-colors text-base" data-id="element-741">
                      Request My Team Store
                    </button>
                    <p className="text-xs text-gray-500 text-center mt-3" data-id="element-742">
                      Prefer to talk first? Call{' '}
                      <a href="tel:8882188647" className="text-pts-red font-bold hover:underline" data-id="element-743">
                        888.218.8647
                      </a>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>;
}